import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import './primeflex.min.css';
import './primereact.min.css';
import './primeicons.css';
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import tuCni from "./img/tudo_cni.svg";
import cc5g from "./img/cc5g.png";
import mwike from "./img/mwike_sz.png";

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <div>
        {navBar()}
        {/* <LandingPage /> */}
        <App/>
    </div>
);

reportWebVitals();

function navBar() {
    return (
        <nav className={'App-header navbar navbar-expand-lg flex-column'} id="header" style={{ height: "auto", paddingTop: "20px", paddingBottom: "1rem" }}>
            {/* Top row */}
            <div className="w-100 d-flex justify-content-between align-items-center">
                <a href="https://cni.tu-dortmund.de" target="_blank" rel="noreferrer">
                    <img id="tuCni" className="img-fluid headerimg" src={tuCni} alt="" />
                </a>

                <h1 className="flex-grow-1 text-center title m-0">
                    <a href="/" style={{ textDecoration: "none", color: "white" }}>
                        5G Campusnetzplaner Pro
                    </a>
                </h1>

                <div className="d-flex align-items-center">
                    <a href="https://5g.nrw/" target="_blank" rel="noreferrer" id="cc5g">
                        <img id="cc5gImg" className="pe-4 img-fluid headerimg" src={cc5g} alt="" />
                    </a>
                    <a href="https://www.wirtschaft.nrw/ministerium" target="_blank" rel="noreferrer">
                        <img className="pe-4 img-fluid headerimg" src={mwike} style={{ width: "210px" }} alt="" />
                    </a>
                </div>
            </div>

            {/* Second row */}
            {/* <div className="w-100 text-center mt-3">
                <a href="/impressum" className="text-white" style={{ color: "rgba(255, 255, 255, 0.6)", textDecoration: "none", marginRight: "1rem"}}>
                    Impressum
                </a>
                <a href="/datenschutz" className="text-white" style={{ color: "rgba(255, 255, 255, 0.6)", textDecoration: "none" }}>
                    Datenschutz
                </a>
            </div> */}
        </nav>
    );
}

// function navBar() {
//     return (
//         <nav className={'App-header navbar navbar-expand-lg'} id={"header"} style={{height: "300px"}}>
//             <a href={'https://cni.tu-dortmund.de'} target={"_blank"} rel="noreferrer"><img id={"tuCni"}
//                                                                                            className={"img-fluid headerimg"}
//                                                                                            src={tuCni} alt={''}/></a>
//             <h1 className={'flex-grow-1 text-center title'}><a href={'/'} target="_blank" rel="noopener noreferrer"
//                style={{textDecoration: "none", color: "white"}}>5G Campusnetzplaner Pro</a></h1>
//             <a href={'https://5g.nrw/'} target={"_blank"} rel="noreferrer"
//                id={"cc5g"}><img id={"cc5gImg"} className={'pe-4 img-fluid headerimg'} src={cc5g} alt={''}/></a>
//             <a href={'https://www.wirtschaft.nrw/ministerium'} target={"_blank"} rel="noreferrer"><img
//                 className={"pe-4 img-fluid headerimg"} src={mwike} style={{width: "210px"}} alt={''}/></a>
//             {/*<a href={'https://www.6gem.de/de/'} target={"_blank"} rel="noreferrer"><img*/}
//             {/*    className={"pe-4 img-fluid headerimg"} src={sixGem} style={{width: "190px"}} alt={''}/></a>*/}
//             {/*<a href={'https://www.bmbf.de/DE/Home/home_node.html'} target={"_blank"} rel="noreferrer"><img*/}
//             {/*    className={"pe-4 img-fluid headerimg"} src={bmbf} style={{width: "120px"}} alt={''}/></a>*/}
//             {/*<a href={'https://youtu.be/p1VO6klFFFw'} target={"_blank"} className={"text-white"}*/}
//             {/*   rel="noreferrer">Tutorial</a>*/}
//             <a href="/impressum" className="text-white pe-4" style={{ textDecoration: "underline", alignSelf: "center" }}></a>
//         </nav>
//     );
// }
